<template>
  <router-link
    class="menu-label"
    :to="`/${$store.state.lang}${to}`"
    data-apollo-hover
    data-apollo-hover-animation="scale-center"
  >
    <span
      @mouseenter="(event) => $eventHub.$emit('menu-voice-enter', { e: event.currentTarget })"
    >{{ label }}</span>
  </router-link>
</template>

<script>
export default {
  name: 'MenuLabel',

  props: ['label', 'to'],
};
</script>

<style lang="scss" scoped>
.menu-label {
  font-size: rem(22px);
  font-size: $font-size-text;
  margin-right: calc((100vw / 32) * 4);
  transition: color .6s $inOutCubic,
              opacity .6s $inOutCubic,
              transform .6s $inOutCubic;

  @at-root .scrolled & {
    opacity: 0;
    transform: translateY(-30px);
  }

  &.last {
    justify-self: flex-end;
    margin-left: auto;
  }

  @at-root .page-white & {
    color: $color-dark;
  }
}
</style>
